// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-WvxO4k{font-size:8px;line-height:18px}.shadow-yADn7s{text-shadow:0 .5px 1px rgba(0,0,0,.2)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `text-WvxO4k`,
	"shadow": `shadow-yADn7s`
};
export default ___CSS_LOADER_EXPORT___;
